<template>
  <div class="auth-forgot-password">
    <h3 class="auth-forgot-password__title">{{$tAuth('Forgot your password?')}}</h3>

    <BaseAlert v-if="messageSuccess"
               :value="messageSuccess"
               class="_success"/>

    <template v-else>
      <Note :value="$tAuth('reset note')"
            class="auth-forgot-password__comment"
      />
      <TabsBlock v-if="isShowTabs"
                 :initialTab="initialTab"
                 class="auth-forgot-password__tabs-block _white" :tabs="authTabs">
        <template v-slot:tab="{tab}">{{tab.name}}</template>
        <template v-slot:content="{tab}">
          <div @keypress.enter="onSendCode(tab)"
               class="auth-forgot-password__input-wrap 8">


            <button v-if="(tab.input.name === 'email') && !tab.isShowCode "
                    type="button"
                    class="auth-forgot-password__input-btn base-btn base-btn--green"
                    :class="validMail ? null : '_disabled'"
                    @click.prevent="onSendCode(tab)"
            >
              <BasePreloader v-if="pendingSend"/>
              <BaseSvg name="ico-arrow-light"/>
            </button>
            <button v-if="(tab.input.name === 'email') && !tab.isShowCode"
                    type="button"
                    class="auth-forgot-password__input-btn base-btn base-btn--green"
                    :class="validMail ? null : '_disabled'"
                    @click.prevent="onSendCode(tab)"
            >
              <BasePreloader v-if="pendingSend"/>
              <BaseSvg name="ico-arrow-light"/>
            </button>


            <button v-if="(tab.input.name === 'phone') && !tab.isShowCode"
                    type="button"
                    class="auth-forgot-password__input-btn base-btn base-btn--green"
                    :class="{'_disabled':authTabs[1].input.value.length<=12}"
                    @click.prevent="onSendCode(tab)"
            >
              <BasePreloader v-if="pendingSend"/>
              <BaseSvg name="ico-arrow-light"/>
            </button>

            <BaseInputPhone v-if="tab.input.name === 'phone'"
                            :value="tab.input.value"
                            @input="savePhone"
                           :error="tab.input.error"
                           :name="tab.input.name"
                           :readonly="tab.isShowCode"
                           class="auth-forgot-password__input-phone"/>

            <BaseInput v-else
                       v-model="tab.input.value"
                       :error="tab.input.error"
                       :name="tab.input.name"
                       :readonly="tab.isShowCode"
            />
          </div>
          <BaseAlert :value="overallErrorsMix"
                     class="auth-forgot-password__alert  _error"/>
          <template v-if="tab.isShowCode">
            <div @keypress.enter="onClickCode"
                 class="auth-forgot-password__input-wrap _code">
              <button type="button"
                      class="auth-forgot-password__input-btn base-btn base-btn--green"
                      :class="validCode ? null : '_disabled'"
                      @click.prevent="onClickCode"
              >
                <BaseSvg name="ico-arrow-light"/>
              </button>
              <BaseInput v-model="code.value"
                         :error="code.error"
                         name="code"
                         :label="$tAuth('Enter code')"
              />
            </div>

            <a href="#"
               class="auth-forgot-password__resend-link"
               @click.prevent="onSendCode(tab)"
            >
              <BaseSvg name="ico-arrow-repeat"/>
              <span>{{$tAuth('Submit the code again')}}</span>
            </a>
          </template>
        </template>
      </TabsBlock>
      <template v-else>
        <div @keypress.enter="onResetPass">
          <BaseInput v-model="inputsNew.password.value"
                     :error="inputsNew.password.error"
                     :label="$tAuth('Set a new password')"
                     name="password"
                     type="password"
                     class="auth-forgot-password__input"
          />
          <div class="auth-forgot-password__password-info password-info">
            <BaseSvg name="ico-info" class="password-info__ico"/>
            <span class="password-info__text">{{$tAuth('Your password must contain')}}:</span>
            <ul class="password-info__list">
              <li :class="{'_active': passwordLongEnough}"
                  class="password-info__list-item">
                <BaseSvg name="ico-check"/>
                <span>{{$tAuth('At least 6 characters')}}</span>
              </li>
              <li :class="{'_active': passwordHasNumber}"
                  class="password-info__list-item">
                <BaseSvg name="ico-check"/>
                <span>{{$tAuth('Number')}}</span>
              </li>
              <li :class="{'_active': passwordHasLetter}"
                  class="password-info__list-item">
                <BaseSvg name="ico-check"/>
                <span>{{$tAuth('Letter')}}</span>
              </li>
            </ul>
          </div>
          <BaseInput v-model="inputsNew.password2.value"
                     :error="inputsNew.password2.error"
                     :label="$tAuth('Confirm password')"
                     class="auth-forgot-password__input"
                     name="confirm_password"
                     type="password"
          />
          <BaseAlert v-if="passwordErrorMsg"
                     :value="passwordErrorMsg"
                     class="auth-forgot-password__alert  _error"/>

          <button type="button"
                  class="auth-forgot-password__btn-submit base-btn base-btn--green"
                  @click.prevent="onResetPass"
          >
            <BasePreloader v-if="pendingReset"/>
            <span class="base-btn__text">{{$tAuth('Change password')}}</span>
          </button>
        </div>
      </template>
    </template>

  </div>
</template>

<script>
  import formMixins from '../mixins/formMixins'
  import Note from './Note'
  import TabsBlock from './TabsBlock'

  export default {
    mixins: [formMixins],
    components: {
      Note,
      TabsBlock
    },
    props: {
      defaultEmailPhone: String,
    },
    data() {
      return {
        pendingSend: false,
        pendingReset: false,
        authTabs: [
          {
            name: this.$tAuth('E-mail'),
            input: {
              value: '',
              error: null,
              name: 'email'
            },
            isShowCode: false
          },
          {
            name: this.$tAuth('Phone'),
            input: {
              value: '',
              error: null,
              name: 'phone'
            },
            isShowCode: false
          }
        ],
        inputsSend: {
          emailOrPhone: {
            value: '',
            error: null
          }
        },
        inputsNew: {
          token: {
            value: '',
            error: null
          },
          password: {
            value: '',
            error: null
          },
          password2: {
            value: '',
            error: null
          }
        },
        code: {
          value: '',
          error: null
        },
        isShowTabs: true,
        message: null,
        messageSuccess: null,
        initialTab: null,
        passwordErrorMsg: ''
      }
    },
    computed: {
      validMail() {
        return this.validateEmail(this.authTabs[0].input.value)
      },
      validPhone() {
        return this.validatePhone(this.authTabs[1].input.value)
      },
      passwordLongEnough() {
        return this.inputsNew.password.value && this.inputsNew.password.value.length >= 6
      },
      passwordHasNumber() {
        return /\d/.test(this.inputsNew.password.value)
      },
      passwordHasLetter() {
        return /[A-Za-z]/.test(this.inputsNew.password.value)
      },
      validCode() {
        return /^[1-9]{1}[0-9]{6}$/.test(this.code.value)
      }
    },
    methods: {
      onSendCode(tab) {
        this.message = null
        this.resetErrorsMix()
        tab.isShowCode = false

        this.inputsSend.emailOrPhone = tab.input
        if(tab.input.name === 'phone' && tab.input.value.startsWith('+')) {
          this.inputsSend.emailOrPhone.value = this.authTabs[1].input.value.substring(1)
        } else {
          this.inputsSend.emailOrPhone = tab.input
        }
        this.pendingSend = true
        
        this.$store.dispatch('user/forgotPassword', this.createSendDataMix(this.inputsSend))
          .then(data => {
            this.message = data.message || null
            tab.isShowCode = true
          })
          .catch((error => {
            this.errorHandlerMix(error)
          }))
          .finally(() => {
            this.pendingSend = false
          })
      },
      onClickCode() {
        this.isShowTabs = false
      },
      onResetPass() {
        this.messageSuccess = null
        this.resetErrorsMix()

        this.inputsNew.token = this.code

        this.pendingReset = true

        this.$store.dispatch('user/newPassword', this.createSendDataMix(this.inputsNew))
          .then(data => {
            this.messageSuccess = data.message || null
          })
          .catch((error => {
            this.passwordErrorMsg = error.response.data.errors.password2
            // this.errorHandlerMix(error)
          }))
          .finally(() => {
            this.pendingReset = false
          })
      },
      validateEmail(value) {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/img.test(value)
      },
      validatePhone(value) {
        return /([+]{0,1})([0-9]{8,12})/img.test(value)
      },
      savePhone(val) {
        this.authTabs[1].input.value = val
      }
    },
    created() {
      if (this.defaultEmailPhone) {
        if (this.validateEmail(this.defaultEmailPhone)) {
          this.authTabs[0].input.value = this.defaultEmailPhone
        } else if (this.validatePhone(this.defaultEmailPhone)) {
          this.authTabs[1].input.value = this.defaultEmailPhone
          this.initialTab = this.authTabs[1]
        }
      }
    }
  }
</script>

<style lang="less">

</style>
